import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "./routes-path";

import pathFaqs from "./faqs/routes-path";
import Faqs from "./faqs/Faqs";

class Informace extends React.PureComponent<RouteComponentProps<RouteProps>, {}> {

    render() {
        const pathRedirect = "/";

        return <Switch>
            <Route path={pathFaqs} render={(routeProps) => <Faqs />} />

            <Redirect to={pathRedirect} />
        </Switch>;
    }
}

export default withRouter(Informace);